import { Col, Row } from "antd";
import React from "react";
import styles from "./index.module.scss";

export type Props = {};

const Network: React.FC<Props> = (props) => {
  const {} = props;

  return (
    <div>
      <div
        style={{
          fontWeight: 700,
          marginBottom: 15,
          fontSize: 18,
          color: "#1890FF",
        }}
      >
        บริษัทในเครือของเอสซีจี และบริษัทพันธมิตร
      </div>
      <Row>
        <Col span={12}>
          • บริษัท เอสซีจี ซิเมนต์-ผลิตภัณฑ์ก่อสร้าง จำกัด <br />
          • บริษัท เอสซีจี ซิเมนต์ จำกัด <br />
          • บริษัท ปูนซิเมนต์ไทย (ท่าหลวง) จำกัด <br />
          • บริษัท ปูนซิเมนต์ไทย (แก่งคอย) จำกัด <br />
          • บริษัท ปูนซิเมนต์ไทย (ทุ่งสง) จำกัด <br />
          • บริษัท อีโค่ แพลนท์ เซอร์วิสเซส จำกัด <br />
          • บริษัท ปูนซิเมนต์ไทย (ลำปาง) จำกัด <br />
          • บริษัท ผลิตภัณฑ์และวัตถุก่อสร้าง จำกัด <br />
          • บริษัท สยามอุตสาหกรรมวัสดุทนไฟ จำกัด <br />
          • บริษัท ศิลาไทยสงวน (2540) จำกัด <br />
          • บริษัท กรีน คอนเซอร์เวชั่น โซลูชั่น จำกัด <br />
          • บริษัท ศิลาสานนท์ จำกัด <br />
          • บริษัท เอสซีไอ อีโค่ เซอร์วิสเซส จำกัด <br />
          • บริษัท เอสซีจี ดิสทริบิวชั่น จำกัด <br />
          • บริษัท เอสซีจี-บุญถาวร จำกัด <br />
          • บริษัท เอสซีจี เอ็กซพีเรียนซ์ จำกัด <br />
          • บริษัท เอสซีจี ผลิตภัณฑ์ก่อสร้าง จำกัด <br />• บริษัท เอสซีจี
          รูฟฟิ่ง จำกัด
        </Col>
        <Col span={12}>
          • บริษัท กระเบื้องหลังคาซีแพค จำกัด
          <br />
          • บริษัท กระเบื้องหลังคาเซรามิคไทย จำกัด
          <br />
          • บริษัท สยามไฟเบอร์กลาส จำกัด
          <br />
          • บริษัท เอสซีจี แลนด์สเคป จำกัด
          <br />
          • บริษัท สระบุรีรัชต์ จำกัด
          <br />
          • บริษัท ควอลิตี้คอนสตรัคชั่นโปรดัคส์ จำกัด (มหาชน)
          <br />
          • บริษัท คิว-คอน อีสเทอร์น จำกัด
          <br />
          • บริษัท พาเนล เวิลด์ จำกัด
          <br />
          • บริษัท สยามไฟเบอร์ซีเมนต์กรุ๊ป จำกัด
          <br />
          • บริษัท กระเบื้องกระดาษไทย จำกัด
          <br />
          • บริษัท เอสซีจี เซรามิกส์ จำกัด (มหาชน)
          <br />
          • บริษัท โสสุโก้ เซรามิค จำกัด
          <br />
          • บริษัท เซรามิคซิเมนต์ไทย จำกัด
          <br />
          • บริษัท สยามซานิทารีแวร์ จำกัด
          <br />
          • บริษัท สยามซานิทารีแวร์อินดัสทรี จำกัด
          <br />
          • บริษัท สยามซานิทารีแวร์อินดัสทรี (หนองแค) จำกัด
          <br />
          • บริษัท สยามซานิทารีฟิตติ้งส์ จำกัด
          <br />
          • บริษัท เน็กซเตอร์ ลีฟวิ่ง จำกัด
          <br />
        </Col>
      </Row>
    </div>
  );
};
export default Network;
